var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3452 9.02742C18.5246 9.02742 18.6874 9.10572 18.8161 9.23802C18.936 9.37932 18.9964 9.55481 18.9789 9.74021C18.9789 9.80141 18.4992 15.8674 18.2252 18.4206C18.0537 19.9875 17.0436 20.9388 15.5285 20.9649C14.3634 20.991 13.2247 21 12.1034 21C10.913 21 9.74886 20.991 8.61886 20.9649C7.15448 20.9298 6.14352 19.9614 5.98071 18.4206C5.69886 15.8584 5.22795 9.80141 5.2192 9.74021C5.21045 9.55481 5.26997 9.37932 5.39076 9.23802C5.5098 9.10572 5.68136 9.02742 5.86167 9.02742H18.3452ZM13.9583 3C14.7539 3 15.4646 3.55529 15.6703 4.34729L15.8174 5.00428C15.9364 5.53977 16.4003 5.91867 16.9343 5.91867H19.5584C19.9085 5.91867 20.2 6.20937 20.2 6.57926V6.92126C20.2 7.28216 19.9085 7.58185 19.5584 7.58185H4.64247C4.29147 7.58185 4 7.28216 4 6.92126V6.57926C4 6.20937 4.29147 5.91867 4.64247 5.91867H7.26661C7.79966 5.91867 8.26357 5.53977 8.38349 5.00518L8.52091 4.39139C8.73448 3.55529 9.43735 3 10.2417 3H13.9583Z",
  fill: "#DC362E"
});

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.7594773c.svg";
export { ForwardRef as ReactComponent };